module.exports = __webpack_public_path__ + "img/unicorn.ae513806.svg";